import serverApi from "../api/Common";
import '../App.css';
import './Login.css';
import Loader from "../Loader/Loader";
import Alert from "../Alert/Alert";
import TextComponent from './TextComponent/TextComponent';
import LoginForm from './LoginForm/LoginForm';
import React, { Component, Fragment } from 'react';


class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            passwd: '',
            btn: false,
            error: "",
            showError: false,
            ajax: false,
            errorField: false,
            errorFieldMessage: "",
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let state = this.state;
        state[name] = value;
        this.validate();
    }

    handleSubmit(event) {
        const st = this.state;
        const inst = this;
        this.setState({ajax: true, errorField: false});
        let data = {login: st.email, password: st.passwd};
        serverApi.api('login',
            data,
            function (result) {
                if (result.auth) {
                    window.location.href = '/panel.html';
                } else {
                    inst.setState({
                        errorField: true,
                        errorFieldMessage: 'Невірний логін або пароль.',
                        passwd: ''
                    });
                }
                inst.setState({ajax: false});
            },
            function (error) {
                inst.setState({
                    error: "Помилка зв'язку!",
                    showError: true,
                    ajax: false
                });
                inst.validate();

                setTimeout(function () {
                    inst.setState({
                        error: "",
                        showError: false,
                    });
                    inst.validate();
                }, 5000)
            });
        event.preventDefault();
    }

    validate() {
        let st = true;
        let state = this.state;
        let re = /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!re.test(state.email)) {
            st = false;
        }
        if (state.passwd.length < 6) {
            st = false;
        }
        state.btn = st && !state.showError;
        this.setState(state);
    }

    componentDidMount() {
        serverApi.getStatusState(function (res) {
            if (res.auth) {
                window.location.href = '/panel.html';
            }
        });
    }

  render() {
    return (

          <div className="templateContainer">
              <header>
                  <Fragment>
                      <h1>Profi<span>+</span></h1>
                  </Fragment>
              </header>
              <main className="mt-5">
                  <LoginForm/>
                  <TextComponent/>
              </main>
          </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login/Login.js